import { memo } from 'react';
import type { RootNode } from '@trinity/chat/types/rich-text';
import { BasicRichText } from '../BasicRichText/BasicRichText';

/**
 * RichTextUI — pure presentation component for text widgets.
 *
 * Renders content in read-only Remirror / ProseMirror mode.
 * Accepts content as a serialized JSON object (RootNode).
 *
 * Props-only — no context, no data fetching.
 */
type Props = {
  /** Rich-text content in Remirror (ProseMirror) JSON format */
  content: RootNode | null;
  className?: string;
};

const EMPTY_CONTENT: RootNode = {
  type: 'doc',
  content: [{ type: 'paragraph', content: [] }],
} as unknown as RootNode;

export const RichTextUI = memo(function RichTextUI({ content, className }: Props): React.ReactElement {
  return (
    <BasicRichText
      value={content ?? EMPTY_CONTENT}
      className={className}
    />
  );
});
